module.exports = __webpack_public_path__ + "media/img/auth/cs-logo-545d1fe05f05e0127f566cdcf1792366.svg";